import { createTheme, ThemeOptions } from "@mui/material/styles";

const lightTheme: ThemeOptions = {
  palette: {
    primary: { main: "rgb(233, 94, 65)" },
    secondary: { main: "rgb(46, 161, 221)" },
    background: { default: "#f3f3f3" },
    commonWhite: "#fff",
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          ".MuiInputBase-root.Mui-error": {
            backgroundColor: "rgb(211 47 47 / 12%)",
          },
        },
      },
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
    },
    MuiAlert: {
      defaultProps: {
        variant: "filled",
      },
    },
    MuiCard: {
      defaultProps: {
        variant: "outlined",
        elevation: 0,
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
  },
};

const darkTheme: ThemeOptions = {
  ...lightTheme,
  palette: {
    ...lightTheme.palette,
    primary: {
      main: "rgb(233, 94, 65)",
    },
    secondary: { main: "rgb(46, 161, 221)" },
    commonWhite: "#fff",
    mode: "dark",
    background: {
      default: "#221405",
      paper: "rgb(37 31 27 / 1)",
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          ".MuiInputBase-root.Mui-error": {
            backgroundColor: "rgb(211 47 47 / 12%)",
          },
        },
      },
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
    },
    MuiAlert: {
      defaultProps: {
        variant: "filled",
      },
    },
    MuiCard: {
      defaultProps: {
        variant: "outlined",
        elevation: 0,
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
  },
};

const theme = {
  light: createTheme(lightTheme),
  dark: createTheme(darkTheme),
};

export default theme;
